module.exports = ".container {\n    margin-top:20px;\n    width: 800px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.cardTitle {\n    margin-top:30px;\n    margin-bottom: 10px;\n}\n\n.cardTitleImg {\n    width: 100%;\n}\n\n.card {\n    margin-top:10px;\n    margin-bottom: 10px;\n}\n\nh4{\n    margin-bottom:0px;\n}\n\na {\n    text-decoration:none;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/faq/faq.component.css
// module id = ./src/app/faq/faq.component.css
// module chunks = main